export default __webpack_public_path__ + "static/194-70fed316170f7bfbe8e8d548a5e68af1.jpg";